/**
 * DeviceSyncStatus - single icon on the right edge of the profiles bar.
 *
 * Shows when there are pending devices awaiting approval (for ANY profile).
 * Displays badge with count. Clicking navigates to /devices.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { usePendingDevices } from '../auth/PendingDevicesContext';
import styles from './DeviceSyncStatus.module.css';

export const DeviceSyncStatus: React.FC = () => {
  const { pendingCount } = usePendingDevices();
  const navigate = useNavigate();

  // Only show when there are pending devices
  if (pendingCount === 0) return null;

  return (
    <button
      type="button"
      className={styles.iconButton}
      onClick={() => navigate('/devices')}
      title={`${pendingCount} device${pendingCount > 1 ? 's' : ''} awaiting approval`}
      aria-label={`${pendingCount} pending device approvals`}
    >
      <div className={styles.iconWrapper}>
        <Clock size={16} className={styles.clockIcon} />
        {pendingCount > 0 && (
          <span className={styles.badge}>
            {pendingCount > 9 ? '9+' : pendingCount}
          </span>
        )}
      </div>
    </button>
  );
};
